import React, { useEffect, useState } from "react";
import Navbar from "../widgets/Navbar";
import Sidebar from "../widgets/Sidebar";
import { useTranslation } from "react-i18next";
import { useIbRequestMutation } from "../../redux/accountApi";
import { useGetallUserQuery } from "../../redux/userApi";
import { Link, useNavigate } from "react-router-dom";

const IbRequest = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: userData, refetch } = useGetallUserQuery();
  const [ibRequest] = useIbRequestMutation();
  const [isChecked, setIsChecked] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState("pending");

  useEffect(() => {
    if (userData) {
      console.log("sdkfjakdaskdjasdj", userData);
      if (userData?.ib_request === "0") {
        setRegistrationStatus("pending");
      }
      if (userData?.ib_request === "1") {
        setRegistrationStatus("requested");
      }
      if (userData?.ib_request === "2") {
        setRegistrationStatus("approved");
        navigate("/partner-dashboard");
      }
      if (userData?.ib_request === "3") {
        setRegistrationStatus("rejected");
      }
    }
  }, [userData]);

  const handleChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleRegistration = async () => {
    const makeRequest = await ibRequest();
    if (makeRequest?.data?.status) {
      setRegistrationStatus("pending");
      refetch();
    } else {
      setRegistrationStatus("error");
    }
  };

  return (
    <div>
      <Navbar />
      <section className="p70  pt-md-5 pb-md-5">
        <div className="container ">
          <div className="row ">
            <Sidebar />
            <div className="col-xl-9 col-lg-8">
              <div className="p-3    bg2 br20 mb-4">
              <div className=" row dashbord">
                {registrationStatus === "pending" ? (
                  <>
                    <h5 className="mb-3">{t("Become a Introducing Broker")}</h5>
                    <p>
                      Make sure your details are correct-after applying, we will
                      reach you to discuess your experiance. We will also answer
                      all the question you might have.
                    </p>
                    <input
                      type="checkbox"
                      className="mr-2"
                      onChange={handleChange}
                      value={isChecked}
                    />
                    <span className="me-2">
                      {t("I have read and agree to the ")}{" "}
                      <a href="#!" className="underscore">
                        IB Agreement
                      </a>
                    </span>
                    <div className="mt-3 text-right">
                      <button
                        className="btn btn-primary"
                        onClick={handleRegistration}
                        disabled={!isChecked}
                      >
                        {t("Register")}
                      </button>
                    </div>
                  </>
                ) : registrationStatus === "requested" ? (
                  <div className="text-center">
                    <span className="split_icon mb-3">
                      <i class="bi bi-hourglass-split"></i>
                    </span>
                    <h4> Partner Request Pending</h4>
                    <p>
                      Your partnership request is under review and we'll confirm
                      with you shortly. Stay tuned!
                    </p>
                    <p>
                      If you face any issue, please visit our{" "}
                      <u>
                        <Link to={"/support"} className="strong">
                          Customer Support
                        </Link>{" "}
                      </u>
                      or Email us at{" "}
                      <u>
                        <a
                          href="mailto:support@luminmarkets.com"
                          className="strong"
                        >
                          support@luminmarkets.com
                        </a>
                      </u>
                      .
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="text-center">
                      <span className="split_icon_reject mb-3">
                        <i class="bi bi-x-circle"></i>
                      </span>
                      <h4>Partner Request Rejected</h4>
                      <p>
                        Unfortunately, your partnership request has been
                        rejected. If you have any questions or need
                        clarification, feel free to contact us.
                      </p>
                      <p>
                        If you face any issue, please visit our{" "}
                        <u>
                          <Link to={"/support"} className="strong">
                            Customer Support
                          </Link>{" "}
                        </u>
                        or Email us at{" "}
                        <u>
                          <a
                            href="mailto:support@dyntech.io"
                            className="strong"
                          >
                            support@dyntech.io
                          </a>
                        </u>
                        .
                      </p>
                    </div>
                  </>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IbRequest;
